import React from 'react';

type Props = {
  href: string;
  children: React.ReactNode;
};

/** フォーム下に中央寄せで置く補助リンク（「パスワードをお忘れの方はこちら」「ログイン画面に戻る」） */
const AuthLink: React.FC<Props> = ({ href, children }) => (
  <div className="mt-4 flex justify-center">
    <a href={href} className="text-body-sm text-tt-foreground-sub hover:text-primary hover:underline">
      {children}
    </a>
  </div>
);

export default AuthLink;
